import React from 'react';
import { Route, Switch } from 'react-router';
import loadable from '@loadable/component';

import { ROUTES } from './auth.constants';
import { SignUpLoading } from './sign-up-loading/sign-up-loading';

const ChallengeSoftwareTokenMfa = loadable(() => import('./challenge-software-token-mfa/challenge-software-token-mfa'));
const ChallengeSmsMfa = loadable(() => import('./challenge-sms-mfa/challenge-sms-mfa'));
const SignInContainer = loadable(() => import('./sign-in/sign-in-container'));
const SignUpSinglePageContainer = loadable(() => import('./sign-up-single-page/sign-up-single-page-container'));
const SignUpConfirmationContainer = loadable(() => import('./sign-up-confirmation/sign-up-confirmation-container'));
const ChallengeNewPasswordRequiredContainer = loadable(() => import('./challenge-new-password-required/challenge-new-password-required-container'));
const ForgotPasswordContainer = loadable(() => import('./forgot-password/forgot-password-container'));
const ConfirmForgotPasswordContainer = loadable(() => import('./confirm-forgot-password/confirm-forgot-password-container'));
const SplashScreenContainer = loadable(() => import('./splash-screen/splash-screen-container'));
const UpdateSignUpDataContainer = loadable(() => import('./check-sign-up-data/update-sign-up-data/update-sign-up-data-container'));

export const Auth = () => (
    <Switch>
        <Route
            exact
            path={ROUTES.SIGN_IN}
            component={SignInContainer}
        />
        <Route
            exact
            path={ROUTES.CHALLENGE_NEW_PASSWORD_REQUIRED}
            component={ChallengeNewPasswordRequiredContainer}
        />
        <Route
            exact
            path={ROUTES.CHALLENGE_SMS_MFA}
            component={ChallengeSmsMfa}
        />
        <Route
            exact
            path={ROUTES.CHALLENGE_SOFTWARE_TOKEN_MFA}
            component={ChallengeSoftwareTokenMfa}
        />
        <Route
            path={ROUTES.SIGN_UP_LOADING}
            component={SignUpLoading}
        />
        <Route
            path={ROUTES.SIGN_UP_SINGLE_PAGE}
            component={SignUpSinglePageContainer}
        />
        <Route
            path={ROUTES.SIGN_UP}
            component={SignUpSinglePageContainer}
        />
        <Route
            exact
            path={ROUTES.SIGN_UP_CONFIRMATION}
            component={SignUpConfirmationContainer}
        />
        <Route
            exact
            path={ROUTES.FORGOT_PASSWORD}
            component={ForgotPasswordContainer}
        />
        <Route
            exact
            path={ROUTES.CONFIRM_FORGOT_PASSWORD}
            component={ConfirmForgotPasswordContainer}
        />
        <Route
            exact
            path={ROUTES.SPLASH_SCREEN}
            component={SplashScreenContainer}
        />
        <Route
            exact
            path={ROUTES.CONFIRM_INVITE}
            component={SplashScreenContainer}
        />
        <Route
            exact
            path={ROUTES.UPDATE_SIGN_UP_DATA}
            component={UpdateSignUpDataContainer}
        />
    </Switch>
);
